import { Stack, styled } from '@mui/material'
import {
  getGenders,
  getInterviewReservationSteps,
  getInterviewReservationSteps2,
  getYesNos,
  getAvailabilityOfApplication,
} from '../../containers/common/codeMaster'
import {
  interviewReservationStep,
  interviewReservationStep2,
  yesNo,
  interviewAcceptMethod
} from '../../containers/common/constant/classification'
import { OperationId } from '../../containers/common/constant/operationLog'
import { memberUrl } from '../../containers/common/constant/appUrl'
import { useAction, child, Inputs } from '../../containers/interviewReservationForm/interviewReservationFormService'
import { translate } from '../../i18n'
import { AttentionLabel } from '../components/common/attentionLabel'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { Dialog } from '../components/common/dialog'
import { BackButton } from '../components/common/buttons/backButton'
import { ButtonL } from '../components/common/buttons/buttonL'
import { ButtonOutlinedS } from '../components/common/buttons/buttonOutlinedS'
import { ButtonS } from '../components/common/buttons/buttonS'
import { ElevatedCard } from '../components/common/elevatedCard'
import { FlexboxRowTop, Separator } from '../components/common/flexboxes'
import { GContainer, GItem, GItemContainer, RightGItem } from '../components/common/grids'
import { InfoCard } from '../components/common/infoCard'
import { DatePicker } from '../components/common/inputs/datePicker'
import { Form } from '../components/common/inputs/form'
import { RadioButtonGroup } from '../components/common/inputs/radioButtonGroup'
import { TextBox } from '../components/common/inputs/textBox'
import { CheckBox } from '../components/common/inputs/checkBox'
import { StepBar } from '../components/common/stepBar'
import { ChildSelectDialog } from '../components/accountConfirmation/childSelectDialog'
import { ChildAllergyUnit } from '../components/common/member/childAllergyUnit'
import { ChildDiseaseUnit } from '../components/common/member/childDiseaseUnit'
import { ChildEatingUnit } from '../components/common/member/childEatingUnit'
import { ChildFebrileSeizureUnit } from '../components/common/member/childFebrileSeizureUnit'
import { ChildHospitalAdmissionUnit } from '../components/common/member/childHospitalAdmissionUnit'
import { ChildMedicalHistoryUnit } from '../components/common/member/childMedicalHistoryUnit'
import { ChildPredispositionUnit } from '../components/common/member/childPredispositionUnit'
import { ChildSymptomUnit } from '../components/common/member/childSymptomUnit'
import { ChildVaccinationUnit } from '../components/common/member/childVaccinationUnit'
import { Link } from '../components/common/link'
import TempFileField from '../components/interviewReservationForm/fields/tempFileField'
import FacilityinputField from '../components/interviewReservationForm/fields/facilityInputsField'
import { Control } from 'react-hook-form'
import { TEMP_FILE_CONDITION } from '../../containers/common/constant/projectMst'
import { OutLimitAgeChilds } from '../../containers/common/acceptAgeLimit'
import { NotAcceptAgeDialog } from '../components/common/interviews/notAcceptAgeDialog'

const InformationAndNote = styled('div')({
  paddingLeft: '20px',
  margin: '0',
  whiteSpace: 'pre-wrap',
})

const InformationAndNoteWithBr = styled('div')({
  paddingLeft: '20px',
  margin: '10px 0px 0px 0px',
  whiteSpace: 'pre-wrap',
})

const DivWithBr = styled('div')({
  whiteSpace: 'pre-wrap',
})

export const InterviewReservationForm = () => {
  const {
    formMethods,
    autoCompleteAddress,
    onSubmit,
    childBirthdayLimitDate,

    isOpenInterviewChildSelect,
    onCloseInterviewChildSelect,
    uninterviewedChilds,
    interviewedChildsAndStatus,
    isDisabledResidenceCategory,
    residenceCategories,
    isDisabledAddress1,
    emergencyContactFlag,
    watchAllFields,
    sysCtrl,
    facility,
    projectMst,
    category,
    diseaseCategory,
    medicalHistoryCategory,
    symptomCategory,
    vaccinationCategory,
    categoryMap,
    goNext,
    isSubmitDialogOpen,
    closeSubmitDialog,
    outLimitAgeChilds,
    closeAgeLimitDialog,
  } = useAction()

  const control: Control<Inputs> = formMethods.control

  // 書類フィールド
  const tempDocField = (index: number) => {
    if (projectMst?.interviewDocFlag === TEMP_FILE_CONDITION.USED_BOTH) {
      return (
        <GItemContainer xs={12}>
          <GItem xs={12}>
            <TempFileField
              childNum={index}
              note={translate('interviewReservationForm.label.tempFile')}
              tempFileNote={projectMst ? projectMst.interviewDocNote : ''}
              control={control}
            />
          </GItem>
        </GItemContainer>
      )
    }
  }

  // 任意項目フィールド
  const facilityInputField = (childNum: number) => {
    if (facility?.interviewFacilityInputFieldsDisplayFlag === yesNo.yes && facility?.interviewFacilityInputFields) {
      const sortInputFields = facility?.interviewFacilityInputFields.sort((a: any, b: any) => a.order - b.order)
      return (
        <GItemContainer xs={12}>
          {sortInputFields.map((input: any, index: number) => {
            return(
              <FacilityinputField
                key={index}
                childNum={childNum}
                id={input.id}
                label={input.label}
                options={input.options}
                inputType={input.inputType}
                mustFlag={input.mustFlag}
              />
            )
          })}
        </GItemContainer>
      )
    }
  }

  return (
    <>
      <Stack spacing={2}>
        <ChildSelectDialog
          isOpen={isOpenInterviewChildSelect}
          onClose={onCloseInterviewChildSelect}
          childs={uninterviewedChilds}
          interviewedChildsAndStatus={interviewedChildsAndStatus}
          isShowToNextButton={!!uninterviewedChilds.length}
          isInterviewBulkReception={sysCtrl.interviewBulkReceptionFlag}
        />
        <Dialog
          isOpen={isSubmitDialogOpen}
          onClose={closeSubmitDialog}
          isShownCloseButton={false}
          formMethods={formMethods}
          onSubmit={goNext}
          buttons={
            <>
              <ButtonOutlinedS onClick={closeSubmitDialog}>{translate('interviewReservationForm.button.back')}</ButtonOutlinedS>
              <ButtonS type="submit">{translate('interviewReservationForm.button.yes')}</ButtonS>
            </>
          }
          maxWidth={'xs'}
          fullWidth
        >
          <DivWithBr>
            { facility?.interviewRequestNotice }
          </DivWithBr>
        </Dialog>
        {
          facility && facility.pmInterviewBeforeDayFlag === yesNo.yes && facility.interviewBeforeDayFlag === yesNo.yes &&
          <NotAcceptAgeDialog 
          isOpen={outLimitAgeChilds.filter((child: OutLimitAgeChilds) => child.isOver || child.isUnder).length > 0}
          closeButtonText={translate('system.button.back')}
          close={closeAgeLimitDialog}
          facility={facility}
          outLimitAgeChilds={outLimitAgeChilds}
          />
        }
      </Stack>
      <Form formMethods={formMethods} onSubmit={onSubmit}>
        <Stack spacing={2}>
          <GContainer>
            <GItem md={3}></GItem>
            <GItem xs={12} md={6}>
              <Stack spacing={2}>
                <div>
                  <StepBar
                    activeStepValue={
                      (facility?.interviewDailyAcceptFlag === yesNo.yes
                        && facility?.interviewAcceptMethod === interviewAcceptMethod.interviewSlots)
                        ? interviewReservationStep2.step2
                        : interviewReservationStep.step1
                    }
                    stepValueLabels={
                      (facility?.interviewDailyAcceptFlag === yesNo.yes
                        && facility?.interviewAcceptMethod === interviewAcceptMethod.interviewSlots)
                        ? getInterviewReservationSteps2()
                        : getInterviewReservationSteps()
                    }
                  />
                  <InfoCard>
                    <InformationAndNote>
                      {facility?.interviewRequestInformation}
                    </InformationAndNote>
                    {
                      (facility?.interviewDailyAcceptFlag === yesNo.yes
                        && facility?.interviewAcceptMethod === interviewAcceptMethod.applicationOnly)
                      && (
                        <InformationAndNoteWithBr>
                          {facility?.interviewNote}
                        </InformationAndNoteWithBr>
                      )
                    }
                  </InfoCard>
                </div>
                <div>
                  <GContainer rowSpacing={3}>
                    <GItemContainer xs={12}>
                      <GItem xs={12}>
                        <AttentionLabel>*</AttentionLabel>
                        {translate('interviewReservationForm.label.parentName')}
                      </GItem>
                      <GItem xs={12}>
                        <TextBox
                          name="parentName"
                          label={translate('interviewReservationForm.label.parentName')}
                          maxLength={100}
                          required
                        />
                      </GItem>
                    </GItemContainer>
                    <GItemContainer xs={12}>
                      <GItem xs={12}>
                        <AttentionLabel>*</AttentionLabel>
                        {translate('interviewReservationForm.label.parentKana')}
                      </GItem>
                      <GItem xs={12}>
                        <TextBox
                          name="parentKana"
                          label={translate('interviewReservationForm.label.parentKana')}
                          maxLength={100}
                          textType="katakana"
                          required
                        />
                      </GItem>
                    </GItemContainer>
                    <GItemContainer xs={12}>
                      <GItem xs={12}>
                        <AttentionLabel>*</AttentionLabel>
                        {translate('interviewReservationForm.label.postalCode')}
                      </GItem>
                      <GItem xs={12}>
                        <FlexboxRowTop>
                          <TextBox
                            name="postalCode"
                            label={translate('interviewReservationForm.label.postalCode')}
                            textType="postalCode"
                            maxLength={8}
                            required
                          />
                          <Separator />
                          <ButtonOutlinedS onClick={autoCompleteAddress}>
                            {translate('interviewReservationForm.button.autoComplete')}
                          </ButtonOutlinedS>
                        </FlexboxRowTop>
                      </GItem>
                    </GItemContainer>
                    <GItemContainer xs={12}>
                      <GItem xs={12}>
                        <AttentionLabel>*</AttentionLabel>
                        {translate('interviewReservationForm.label.prefecturesAndMunicipalities')}
                      </GItem>
                      <GItem xs={12}>
                        <TextBox
                          name="address1"
                          label={translate('interviewReservationForm.label.prefecturesAndMunicipalities')}
                          maxLength={100}
                          required
                          disabled={isDisabledAddress1}
                        />
                      </GItem>
                    </GItemContainer>
                    <GItemContainer xs={12}>
                      <GItem xs={12}>
                        <AttentionLabel>*</AttentionLabel>
                        {translate('interviewReservationForm.label.address')}
                      </GItem>
                      <GItem xs={12}>
                        <TextBox
                          name="address2"
                          label={translate('interviewReservationForm.label.address')}
                          maxLength={100}
                          required
                        />
                      </GItem>
                    </GItemContainer>
                    <GItemContainer xs={12}>
                      <GItem xs={12}>{translate('interviewReservationForm.label.buildingNameRoomNumber')}</GItem>
                      <GItem xs={12}>
                        <TextBox
                          name="buildingNameRoomNumber"
                          label={translate('interviewReservationForm.label.buildingNameRoomNumber')}
                          maxLength={100}
                        />
                      </GItem>
                    </GItemContainer>
                    <GItemContainer xs={12}>
                      <GItem xs={12}>
                        <AttentionLabel>*</AttentionLabel>
                        {translate('interviewReservationForm.label.residenceCategory')}
                      </GItem>
                      <GItem xs={12}>
                        <RadioButtonGroup
                          name="residenceCategory"
                          label={translate('interviewReservationForm.label.residenceCategory')}
                          required
                          row
                          buttonValueLabels={residenceCategories}
                          disabled={isDisabledResidenceCategory}
                        />
                      </GItem>
                    </GItemContainer>

                    <GItemContainer xs={12}>
                      <GItem xs={12}>{translate('interviewReservationForm.label.relationship')}</GItem>
                      <GItem xs={12}>
                        <TextBox
                          name="relationship"
                          label={translate('interviewReservationForm.label.relationship')}
                          maxLength={50}
                        />
                      </GItem>
                    </GItemContainer>

                    <GItemContainer xs={12}>
                      <GItem xs={12}>{translate('interviewReservationForm.label.emergencyContact')}</GItem>
                      <GItem xs={12}>
                        <GItem xs={12} >{ emergencyContactFlag ? '登録あり' : '登録なし'}</GItem>
                      </GItem>
                    </GItemContainer>
                    <DivWithBr id="errorMessage"></DivWithBr>

                    {watchAllFields?.children?.map((child: child, index: number) => {
                      const isAvailabilityOfApplication = watchAllFields?.children?.[index]?.availabilityOfApplication === '1'
                      const isInterviewMethodFlagOn = facility?.interviewMethodFlag === yesNo.yes
                      return (
                        <GItemContainer key={index} xs={12} rowSpacing={1}>
                          <GItem xs={12}>
                            <ElevatedCard title={translate('interviewReservationForm.title.child')}>
                              <GContainer rowSpacing={1} >
                                <GItemContainer xs={12}>
                                  <GItem xs={12}>
                                    <RadioButtonGroup
                                      name={`children.${index}.availabilityOfApplication`}
                                      label={translate('interviewReservationForm.label.childGender')}
                                      required
                                      row
                                      buttonValueLabels={getAvailabilityOfApplication()}
                                    />
                                  </GItem>
                                </GItemContainer>
                                <GItemContainer xs={12}>
                                  <GItem xs={12}>
                                    <AttentionLabel>*</AttentionLabel>
                                    {translate('interviewReservationForm.label.childName')}
                                  </GItem>
                                  <GItem xs={12}>
                                    <TextBox
                                      name={`children.${index}.childName`}
                                      label={translate('interviewReservationForm.label.childName')}
                                      maxLength={100}
                                      required
                                      disabled={!isAvailabilityOfApplication}
                                    />
                                  </GItem>
                                </GItemContainer>
                                <GItemContainer xs={12}>
                                  <GItem xs={12}>
                                    <AttentionLabel>*</AttentionLabel>
                                    {translate('interviewReservationForm.label.childKana')}
                                  </GItem>
                                  <GItem xs={12}>
                                    <TextBox
                                      name={`children.${index}.childKana`}
                                      label={translate('interviewReservationForm.label.childKana')}
                                      maxLength={100}
                                      textType="katakana"
                                      required
                                      disabled={!isAvailabilityOfApplication}
                                    />
                                  </GItem>
                                </GItemContainer>
                                <GItemContainer xs={12}>
                                  <GItem xs={12}>
                                    <AttentionLabel>*</AttentionLabel>
                                    {translate('interviewReservationForm.label.childBirthday')}
                                  </GItem>
                                  <GItem xs={12}>
                                    <DatePicker
                                      name={`children.${index}.childBirthday`}
                                      label={translate('interviewReservationForm.label.childBirthday')}
                                      maxDate={childBirthdayLimitDate}
                                      disabled={!isAvailabilityOfApplication || watchAllFields?.children?.[index]?.childInterviewPermitCount > 0}
                                      required
                                    />
                                  </GItem>
                                </GItemContainer>

                                {isAvailabilityOfApplication && !isInterviewMethodFlagOn && (
                                  <>
                                    <GItemContainer xs={12}>
                                      <GItem xs={12}>
                                        <AttentionLabel>*</AttentionLabel>
                                        {translate('interviewReservationForm.label.childGender')}
                                      </GItem>
                                      <GItem xs={12}>
                                        <RadioButtonGroup
                                          name={`children.${index}.childGender`}
                                          label={translate('interviewReservationForm.label.childGender')}
                                          required
                                          row
                                          buttonValueLabels={getGenders()}
                                        />
                                      </GItem>
                                    </GItemContainer>

                                    {categoryMap?.allergyFlag && (
                                      <>
                                      {/* アレルギー(旧) */}
                                        <GItemContainer xs={12}>
                                          <GItem xs={12}>
                                            <AttentionLabel>*</AttentionLabel>
                                            {translate('interviewReservationForm.label.childAllergy')}
                                          </GItem>
                                          <GItem xs={12}>
                                            <RadioButtonGroup
                                              name={`children.${index}.childAllergyFlag`}
                                              label={translate('interviewReservationForm.label.childAllergyFlag')}
                                              required
                                              row
                                              buttonValueLabels={getYesNos().reverse()}
                                            />
                                          </GItem>
                                          <GItem xs={12}>
                                            <TextBox
                                              name={`children.${index}.childAllergy`}
                                              label={translate('interviewReservationForm.label.childAllergyContent')}
                                              maxLength={200}
                                              multiline
                                              minRows={4}
                                              fullWidth
                                            />
                                          </GItem>
                                        </GItemContainer>
                                      </>
                                    )}

                                    {categoryMap?.medicalHistoryContent && (
                                      <>
                                        {/* 既往症(旧) */}
                                        <GItemContainer xs={12}>
                                          <GItem xs={12}>
                                            <AttentionLabel>*</AttentionLabel>
                                            {translate('interviewReservationForm.label.childMedicalHistory')}
                                          </GItem>
                                          <GItem xs={12}>
                                            <RadioButtonGroup
                                              name={`children.${index}.childMedicalHistoryFlag`}
                                              label={translate('interviewReservationForm.label.childMedicalHistoryFlag')}
                                              required
                                              row
                                              buttonValueLabels={getYesNos().reverse()}
                                            />
                                          </GItem>
                                          <GItem xs={12}>
                                            <TextBox
                                              name={`children.${index}.childMedicalHistory`}
                                              label={translate('interviewReservationForm.label.childMedicalHistoryContent')}
                                              maxLength={200}
                                              multiline
                                              minRows={4}
                                              fullWidth
                                            />
                                          </GItem>
                                        </GItemContainer>
                                      </>
                                    )}

                                    {/* アレルギー */}
                                    <GItem xs={12}>
                                      <ChildAllergyUnit
                                        sectionLabel={'アレルギー'}
                                        child={child.childOrig}
                                        categoryMst={category}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 熱性けいれん */}
                                    <GItem xs={12}>
                                      <ChildFebrileSeizureUnit
                                        sectionLabel={'熱性けいれん'}
                                        child={child.childOrig}
                                        categoryMst={category}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 既往症 */}
                                    <GItem xs={12}>
                                      <ChildMedicalHistoryUnit
                                        sectionLabel={'既往症'}
                                        child={child.childOrig}
                                        categoryMst={medicalHistoryCategory}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 食事 */}
                                    <GItem xs={12}>
                                      <ChildEatingUnit
                                        sectionLabel={'食事'}
                                        child={child.childOrig}
                                        categoryMst={category}
                                        hideLink={true}
                                      />
                                    </GItem>


                                    {/* 病気 */}
                                    <GItem xs={12}>
                                      <ChildDiseaseUnit
                                        sectionLabel={'病気'}
                                        child={child.childOrig}
                                        categoryMst={diseaseCategory}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 症状 */}
                                    <GItem xs={12}>
                                      <ChildSymptomUnit
                                        sectionLabel={'症状'}
                                        child={child.childOrig}
                                        categoryMst={symptomCategory}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 予防接種 */}
                                    <GItem xs={12}>
                                      <ChildVaccinationUnit
                                        sectionLabel={'予防接種'}
                                        child={child.childOrig}
                                        categoryMst={vaccinationCategory}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 体質・くせ */}
                                    <GItem xs={12}>
                                      <ChildPredispositionUnit
                                        sectionLabel={'体質・くせ'}
                                        child={child.childOrig}
                                        categoryMst={category}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 入院歴 */}
                                    <GItem xs={12}>
                                      <ChildHospitalAdmissionUnit
                                        sectionLabel={'入院歴'}
                                        child={child.childOrig}
                                        categoryMst={category}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 母子健康手帳番号 */}
                                    {categoryMap?.maternalHandbookNo && <GItemContainer xs={12}>
                                      <GItem xs={12}>
                                        {categoryMap.maternalHandbookNo.required === yesNo.yes && <AttentionLabel>*</AttentionLabel>}
                                        {translate('interviewReservationForm.label.maternalHandbookNo')}
                                      </GItem>
                                      <GItem xs={12}>
                                        <TextBox
                                          name={`children.${index}.maternalHandbookNo`}
                                          label={translate('interviewReservationForm.label.maternalHandbookNo')}
                                          maxLength={20}
                                          required={categoryMap.maternalHandbookNo.required === yesNo.yes}
                                        />
                                      </GItem>
                                    </GItemContainer>}
                                    {tempDocField(index)}
                                    {facilityInputField(index)}
                                    <GItemContainer xs={12}>
                                      <GItem xs={12}>{translate('interviewReservationForm.label.note')}</GItem>
                                      <GItem xs={12}>
                                        <TextBox
                                          name={`children.${index}.note`}
                                          label={translate('interviewReservationForm.label.note')}
                                          maxLength={1000}
                                          multiline
                                          minRows={4}
                                          fullWidth
                                        />
                                      </GItem>
                                    </GItemContainer>
                                    {(facility?.interviewDailyAcceptFlag === yesNo.no
                                      || facility?.interviewAcceptMethod !== interviewAcceptMethod.interviewSlots)
                                      && facility?.interviewExistingMemberCheckFlag === yesNo.yes
                                      && facility?.interviewExistingMemberCheckInformation
                                      && (
                                        <GItemContainer xs={12}>
                                          <GItem xs={12}>
                                            <InfoCard>
                                              <InformationAndNote>
                                                {facility.interviewExistingMemberCheckInformation}
                                              </InformationAndNote>
                                            </InfoCard>
                                          </GItem>
                                        </GItemContainer>
                                      )
                                    }
                                    {facility?.interviewExistingMemberCheckFlag === yesNo.yes
                                      && (
                                        <GItemContainer xs={12}>
                                          <GItem xs={12}>
                                            <CheckBox
                                              name={`children.${index}.existingMemberFlag`}
                                              label={translate('interviewReservationForm.label.existingMemberFlag')}
                                              valueAtCheck={yesNo.yes}
                                              disabled={child.existingMemberEditFlag === yesNo.yes}
                                            >
                                              {translate('interviewReservationForm.label.existingMemberFlag')}
                                            </CheckBox>
                                          </GItem>
                                        </GItemContainer>
                                      )
                                    }
                                    <GItemContainer xs={12}>
                                      <GItem xs={12}>
                                        <div>{translate('interviewReservationForm.label.facilityNumber')}</div>
                                        <div>{translate('interviewReservationForm.label.facilityNumberSupplement')}</div>
                                      </GItem>
                                      <GItem xs={12}>
                                        <TextBox
                                          name={`children.${index}.facilityNumber`}
                                          label={translate('interviewReservationForm.label.facilityNumber')}
                                          maxLength={12}
                                          fullWidth
                                        />
                                      </GItem>
                                    </GItemContainer>
                                  </>
                                )}

                                {isAvailabilityOfApplication && isInterviewMethodFlagOn && (
                                  <>
                                    <GItemContainer xs={12}>
                                      <GItem xs={12}>
                                        <AttentionLabel>*</AttentionLabel>
                                        {translate('interviewReservationForm.label.childGender')}
                                      </GItem>
                                      <GItem xs={12}>
                                        <RadioButtonGroup
                                          name={`children.${index}.childGender`}
                                          label={translate('interviewReservationForm.label.childGender')}
                                          required
                                          row
                                          buttonValueLabels={getGenders()}
                                        />
                                      </GItem>
                                    </GItemContainer>

                                    {/* アレルギー */}
                                    <GItem xs={12}>
                                      <ChildAllergyUnit
                                        sectionLabel={'アレルギー'}
                                        child={child.childOrig}
                                        categoryMst={category}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 熱性けいれん */}
                                    <GItem xs={12}>
                                      <ChildFebrileSeizureUnit
                                        sectionLabel={'熱性けいれん'}
                                        child={child.childOrig}
                                        categoryMst={category}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 既往症 */}
                                    <GItem xs={12}>
                                      <ChildMedicalHistoryUnit
                                        sectionLabel={'既往症'}
                                        child={child.childOrig}
                                        categoryMst={medicalHistoryCategory}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 食事 */}
                                    <GItem xs={12}>
                                      <ChildEatingUnit
                                        sectionLabel={'食事'}
                                        child={child.childOrig}
                                        categoryMst={category}
                                        hideLink={true}
                                      />
                                    </GItem>


                                    {/* 病気 */}
                                    <GItem xs={12}>
                                      <ChildDiseaseUnit
                                        sectionLabel={'病気'}
                                        child={child.childOrig}
                                        categoryMst={diseaseCategory}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 症状 */}
                                    <GItem xs={12}>
                                      <ChildSymptomUnit
                                        sectionLabel={'症状'}
                                        child={child.childOrig}
                                        categoryMst={symptomCategory}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 予防接種 */}
                                    <GItem xs={12}>
                                      <ChildVaccinationUnit
                                        sectionLabel={'予防接種'}
                                        child={child.childOrig}
                                        categoryMst={vaccinationCategory}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 体質・くせ */}
                                    <GItem xs={12}>
                                      <ChildPredispositionUnit
                                        sectionLabel={'体質・くせ'}
                                        child={child.childOrig}
                                        categoryMst={category}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 入院歴 */}
                                    <GItem xs={12}>
                                      <ChildHospitalAdmissionUnit
                                        sectionLabel={'入院歴'}
                                        child={child.childOrig}
                                        categoryMst={category}
                                        hideLink={true}
                                      />
                                    </GItem>

                                    {/* 母子健康手帳番号 */}
                                    {categoryMap?.maternalHandbookNo && <GItemContainer xs={12}>
                                      <GItem xs={12}>
                                        <AttentionLabel>*</AttentionLabel>
                                        {translate('interviewReservationForm.label.maternalHandbookNo')}
                                      </GItem>
                                      <GItem xs={12}>
                                        <TextBox
                                          name={`children.${index}.maternalHandbookNo`}
                                          label={translate('interviewReservationForm.label.maternalHandbookNo')}
                                          maxLength={20}
                                          required={categoryMap.maternalHandbookNo.required === yesNo.yes}
                                        />
                                      </GItem>
                                    </GItemContainer>}
                                    {tempDocField(index)}
                                    {facilityInputField(index)}
                                    <GItemContainer xs={12}>
                                      <GItem xs={12}>{translate('interviewReservationForm.label.note')}</GItem>
                                      <GItem xs={12}>
                                        <TextBox
                                          name={`children.${index}.note`}
                                          label={translate('interviewReservationForm.label.note')}
                                          maxLength={1000}
                                          multiline
                                          minRows={4}
                                          fullWidth
                                        />
                                      </GItem>
                                    </GItemContainer>
                                    {(facility?.interviewDailyAcceptFlag === yesNo.no
                                      || facility?.interviewAcceptMethod !== interviewAcceptMethod.interviewSlots)
                                      && facility?.interviewExistingMemberCheckFlag === yesNo.yes
                                      && facility?.interviewExistingMemberCheckInformation
                                      && (
                                        <GItemContainer xs={12}>
                                          <GItem xs={12}>
                                            <InfoCard>
                                              <InformationAndNote>
                                                {facility.interviewExistingMemberCheckInformation}
                                              </InformationAndNote>
                                            </InfoCard>
                                          </GItem>
                                        </GItemContainer>
                                      )
                                    }
                                    {facility?.interviewExistingMemberCheckFlag === yesNo.yes
                                      && (
                                        <GItemContainer xs={12}>
                                          <GItem xs={12}>
                                            <CheckBox
                                              name={`children.${index}.existingMemberFlag`}
                                              label={translate('interviewReservationForm.label.existingMemberFlag')}
                                              valueAtCheck={yesNo.yes}
                                              disabled={child.existingMemberEditFlag === yesNo.yes}
                                            >
                                              {translate('interviewReservationForm.label.existingMemberFlag')}
                                            </CheckBox>
                                          </GItem>
                                        </GItemContainer>
                                      )
                                    }
                                    <GItemContainer xs={12}>
                                      <GItem xs={12}>
                                        <div>{translate('interviewReservationForm.label.facilityNumber')}</div>
                                        <div>{translate('interviewReservationForm.label.facilityNumberSupplement')}</div>
                                      </GItem>
                                      <GItem xs={12}>
                                        <TextBox
                                          name={`children.${index}.facilityNumber`}
                                          label={translate('interviewReservationForm.label.facilityNumber')}
                                          maxLength={12}
                                          fullWidth
                                        />
                                      </GItem>
                                    </GItemContainer>
                                  </>
                                )}
                              </GContainer>
                            </ElevatedCard>
                          </GItem>
                        </GItemContainer>
                      )
                    })}
                  </GContainer>
                  <GItemContainer xs={12}>
                    <RightGItem xs={12}>
                      <Link to={memberUrl.url()} operationLog={{ operationId: OperationId.OP_00000039 }}>
                        会員情報で編集
                      </Link>
                    </RightGItem>
                  </GItemContainer>
                </div>
              </Stack>
            </GItem>
            <GItem md={3}></GItem>
          </GContainer>
          <BottomButtonGroup>
            <ButtonL fullWidth type="submit">
              {translate('interviewReservationForm.button.confirmation')}
            </ButtonL>
            <BackButton />
          </BottomButtonGroup>
        </Stack>
      </Form>
    </>
  )
}
